"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var graphics_1 = require("./graphics");
var input_1 = require("./input");
var create = function () {
    var backgroundColor = null;
    var update = null;
    var render = null;
    // used for calculating the Delta Time for the Frame
    var prevTime = 0;
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var graphics = graphics_1.default.create(ctx);
    canvas.id = 'bramble-game';
    var mouseInput = input_1.mouse.create(canvas);
    var keyboardInput = input_1.keyboard.create(canvas);
    var setBackgroundColor = function (color) {
        backgroundColor = color;
    };
    var attachTo = function (element) {
        element.appendChild(canvas);
    };
    var setUpdate = function (callback) {
        update = callback;
    };
    var setRender = function (callback) {
        render = callback;
    };
    var inputState = {
        keyboard: keyboardInput.getState(),
        mouse: mouseInput.getState(),
    };
    var step = function () {
        if (update) {
            inputState.keyboard = keyboardInput.getState();
            inputState.mouse = mouseInput.getState();
            update((performance.now() - prevTime) / 1000, inputState);
        }
        if (render) {
            if (backgroundColor) {
                graphics.clear(backgroundColor);
            }
            render(graphics);
        }
        mouseInput.update();
        keyboardInput.update();
        window.requestAnimationFrame(step);
        prevTime = performance.now();
    };
    var start = function () {
        mouseInput.start();
        keyboardInput.start();
        window.requestAnimationFrame(step);
    };
    var setSize = function (width, height) {
        canvas.width = width;
        canvas.height = height;
    };
    // Smoothing must be re-applied if any of the following is called
    //   - setSize
    var setSmoothing = function (to) {
        if (to === void 0) { to = true; }
        ctx.imageSmoothingEnabled = to;
    };
    var disableContextMenu = function () {
        canvas.addEventListener('contextmenu', function (e) {
            e.preventDefault();
        });
    };
    return {
        attachTo: attachTo,
        setSize: setSize,
        setUpdate: setUpdate,
        setRender: setRender,
        setBackgroundColor: setBackgroundColor,
        canvas: canvas,
        disableContextMenu: disableContextMenu,
        setSmoothing: setSmoothing,
        start: start
    };
};
exports.default = {
    create: create
};
